import { useEffect } from "react";

import { Nav, Footer } from "../components/Nav";
import cover from "../images/Memolog/Memolog Cover.png";

import flowImg from "../images/Memolog/flowchart.jpg";
import colorsImg from "../images/Memolog/colors.png";
import iconImg from "../images/Memolog/app icon.png";
import img1 from "../images/Memolog/memolog 1.png";
import img2 from "../images/Memolog/memolog 2.png";
import img3 from "../images/Memolog/memolog 3.png";
import img4 from "../images/Memolog/memolog 4.png";
import img5 from "../images/Memolog/memolog 5.png";
import poster from "../images/Memolog/Memolog Poster.png";
import {
  ProjectInfo,
  TextSection,
  MoreSection,
} from "../components/ProjectDetails";

export default function MemoLog() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <header id="project-cover">
        <Nav color="white" />

        <h1>MemoLog</h1>
        <p>
          Capture notes and memories with this beautifully designed notes app!
        </p>
        <img id="cover" src={cover} alt="Cakery Cover" />
      </header>

      <main id="project-detail-main">
        <ProjectInfo
          role={["UI Designer"]}
          team={["Solo Project"]}
          toolkit={["Adobe Illustrator"]}
          duration="1 Month (2023)"
        />

        <TextSection type="callout" header="project overview" title="The Goal">
          <p>
            MemoLog is a note app designed for archiving your memories and other
            personal notes. With a passion for cherishing memories through
            journaling, my goal is to create an app to help users capture
            moments and preserve their treasured experiences. Whether it's
            archiving recipes, travel trips, or crochet patterns, MemoLog
            provides a space for your memories to be kept and cherished.
          </p>
        </TextSection>

        <TextSection
          type="normal-text"
          header="Planning"
          title="Narrowing the Scope"
        >
          <p>
            <strong>Target Audiences</strong>
          </p>
          <ul>
            <li>Teens to early middle age (12-40)</li>
            <li>Individuals who enjoy planning or capturing memories</li>
          </ul>
          <p>Potential Use Cases</p>
          <ul>
            <li>Capture Notes</li>
            <li>Travel Planning</li>
            <li>Memory Keeping</li>
            <li>Archiving Recipes</li>
          </ul>
        </TextSection>

        <TextSection
          type="normal-text"
          header="Planning"
          title="User Flow Chart"
        >
          <p>
            To ensure a smooth user experience, I began the design process by
            creating a flow chart that outlines the app's pages and the ways
            users will interact with it.
          </p>
          <img
            src={flowImg}
            className="smaller-img"
            alt="MemoLog User Flow Chart"
          />
        </TextSection>

        <TextSection type="callout" header="Final Design" title="Colors">
          <p>
            The app's blue accent color Evokes a sense of calm and peace,
            providing a soothing contrast to the often cluttered nature of
            notes. By keeping the color palette simple, we direct the emphasis
            to the content of each note.
          </p>
          <img src={colorsImg} className="smaller-img" alt="MemoLog Colors" />
        </TextSection>

        <TextSection type="callout" header="Final Design" title="App Icon">
          <p>
            The app icon embodies MemoLog's minimalist design and includes
            distinct elements like the quick add button.
          </p>
          <img src={iconImg} className="smaller-img" alt="MemoLog App Icon" />
        </TextSection>

        <TextSection
          type="callout"
          header="Final App Walkthrough"
          title="Getting Started"
        >
          <p>
            Welcome to MemoLog! Log in with your email or create an account to
            get started. Easily access all archived notes organized into folders
            for different categories. Use the quick add button in the bottom
            right for fast and convenient note logging.
          </p>

          <div className="three-img">
            <img src={img1} className="smaller-img" alt="MemoLog App Mockup" />
            <img src={img2} className="smaller-img" alt="MemoLog App Mockup" />
            <img src={img5} className="smaller-img" alt="MemoLog App Mockup" />
          </div>
          <p>
            Need to find something? The quick search feature lets you instantly
            locate notes or create a new one on the spot.
          </p>
        </TextSection>

        <TextSection
          type="callout"
          header="Final App Walkthrough"
          title="Creating Notes"
        >
          <p>
            Create notes with ease using options to add text, images,
            checklists, and bullet points, allowing for better organization and
            customization.
          </p>
          <div className="three-img">
            <img src={img3} className="smaller-img" alt="MemoLog App Mockup" />
            <img src={img4} className="smaller-img" alt="MemoLog App Mockup" />
          </div>
        </TextSection>

        <TextSection
          type="normal-text"
          header="Final Design"
          title="All Designs"
        >
          <img src={poster} alt="MemoLog All Designs" />
        </TextSection>
      </main>
      <MoreSection exclude={["memolog"]} />

      <Footer />
    </>
  );
}
